import { SignupFormData } from '@magoosh/act/organisms/signup/types';

export enum SignupFormActionTypes {
  INITIALIZE_SIGNUP_FORM = 'SIGNUP_FORM/INITIALIZE'
}

export const initializeSignupForm = (props: SignupFormData) => ({
  type: SignupFormActionTypes.INITIALIZE_SIGNUP_FORM,
  signup: props
});
